import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';

var _templateObject, _templateObject2, _templateObject3;
var setGap = function setGap(gap) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  gap: ", "rem;\n"])), gap / 10);
};
var setGapX = function setGapX(gap) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  column-gap: ", "rem;\n"])), gap / 10);
};
var setGapY = function setGapY(gap) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  row-gap: ", "rem;\n"])), gap / 10);
};

export { setGap, setGapX, setGapY };
//# sourceMappingURL=styles.js.map
